import { z } from "zod";

/** The reset page's search: Better Auth's GET callback for the reset link sends the person here with ?token=, or
 *  ?error=INVALID_TOKEN. A light module, so the route can validate it without loading the page. */
export const resetSearch = z.object({
  token: z.string().max(512).optional(),
  error: z.string().max(40).optional(),
});

export type ResetSearch = z.infer<typeof resetSearch>;
